<!-- my-loader.component.html -->
<div class="progress-loader" [hidden]="!loading">
   <div class="loading-spinner">
      <!-- <img style="height: 70px; width: 70px;" src="../../assets/img/loading.gif">
      <span class="loading-message"></span> -->
      <div class="spinner-border loading" role="status">
         <span class="sr-only">Loading...</span>
      </div>
   </div>
</div>
